import {
  fetchListing,
  fetchDeleteMany,
} from '@/api/code';
import AuthResponse from '@/service/AuthResponse';
import Notifications from '@/service/Notifications';

export default {
  fetch(context, query = null) {
    const { state, commit } = context;
    commit('setIsLoading', true);
    return fetchListing(state.pagination.page, query)
      .then(res => AuthResponse.validate(res, context))
      .then(res => {
        if (!res) {
          commit('reset');
          return;
        }
        commit('setIsLoading', false);
        if (res.items && res.pagination) {
          commit('setResponse', res);
        }
        return res;
      })
      .catch(e => Notifications.error(
          e.toString() || 'Failed to retrieve codes',
          () => commit('reset')
        )
      )
    ;
  },
  deleteMany(context, codes = null) {
    return fetchDeleteMany(codes)
      .then(res => AuthResponse.validateDelete(res, context))
      .catch(e => Notifications.error(
          e.toString() || 'Failed to remove codes',
          () => commit('reset')
        )
      )
    ;
  },
};
